import classNames from 'classnames';

import type { IconName } from '@/shared/ui/Icon';
import { Icon } from '@/shared/ui/Icon';

import { DAG_LIST_RUN_STATUS_LABEL_MAP } from '@/entities/dag';
import type { DagListRunStatus } from '@/entities/dag';

import styles from './DagStatusBadge.module.css';

const RUN_STATUS_VISUAL: Record<DagListRunStatus, { containerClass: string; icon: IconName; iconColor: string }> = {
  success: {
    containerClass: styles.runStatusSuccess,
    icon: 'check-circle',
    iconColor: 'var(--opds-sem-color-onContainer-colorful-emerald)',
  },
  failure: {
    containerClass: styles.runStatusFailure,
    icon: 'cancel',
    iconColor: 'var(--opds-sem-color-onContainer-colorful-red)',
  },
  running: {
    containerClass: styles.runStatusRunning,
    icon: 'running-circle',
    iconColor: 'var(--opds-sem-color-onContainer-colorful-blue)',
  },
  pending: {
    containerClass: styles.runStatusPending,
    icon: 'pending',
    iconColor: 'var(--opds-sem-color-onContainer-colorful-orange)',
  },
  draft: {
    containerClass: styles.runStatusDraft,
    icon: 'minus-circle',
    iconColor: 'var(--opds-sem-color-onContainer-colorful-gray)',
  },
};

type DagStatusBadgeProps = {
  runStatus?: DagListRunStatus;
};

export const DagStatusBadge = ({ runStatus }: DagStatusBadgeProps) => {
  if (!runStatus) {
    return <span className={styles.empty}>-</span>;
  }

  const visual = RUN_STATUS_VISUAL[runStatus];

  if (!visual) {
    return <span className={styles.empty}>{runStatus}</span>;
  }

  return (
    <div className={classNames(styles.runStatusContainer, visual.containerClass)}>
      <Icon name={visual.icon} width={16} height={16} size={16} color={visual.iconColor} />
      <span className={styles.runStatusLabel}>{DAG_LIST_RUN_STATUS_LABEL_MAP[runStatus]}</span>
    </div>
  );
};
